import { logout } from 'config/user/store/authSlice'
import { useDispatch } from 'react-redux'
import { Button } from './Button'
import { LogoutIcon } from 'components/icons'
import { CSS } from 'theme'
import { useQueryClient } from '@tanstack/react-query'
import { useNavigate, useParams } from 'react-router-dom'
interface LogoutButtonProp {
  css?: CSS
  text?: string
}

export const LogoutButton = ({ css, text }: LogoutButtonProp) => {
  const dispatch = useDispatch()
  const queryClient = useQueryClient()
  const navigate = useNavigate()
  const { lang } = useParams()

  const handleLogout = () => {
    dispatch(logout())
    queryClient.clear()
    navigate(`/${lang || 'en'}`, { replace: true })
    window.location.reload()
  }

  return (
    <Button
      css={css}
      color="gray"
      transparent="asIcon"
      type="button"
      startIcon={<LogoutIcon />}
      onClick={handleLogout}
    >
      {text && text}
    </Button>
  )
}
